import { Translate as $t } from "@/plugins/translate";

export default [
  {
    id: 1,
    value: $t("includes"),
  },
  {
    id: 2,
    value: $t("excludes"),
  },
  {
    id: 3,
    value: $t("is_a"),
  },
  {
    id: 4,
    value: $t("contains"),
  },
  {
    id: 5,
    value: $t("is_not_a"),
  },
  {
    id: 6,
    value: $t("is_more_than"),
  },
  {
    id: 7,
    value: $t("is_less_than"),
  },
  {
    id: 8,
    value: $t("equals"),
  },
];
